import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Discount } from '@webmodule-order/api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'webmodule-order-discount-price',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './discount-price.component.html',
  styles: `
      :host {
          display: block;
      }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DiscountPriceComponent {
  describedby = input.required<string>();
  price = input.required<number>();
  discount = input.required<Discount>();
  isOneTimePayment = input.required<boolean>();

  calculateTotal = computed(() => {
    const price = this.price();
    const discount = this.discount();
    if (discount.amount) {
      return price - (discount.amount ?? 0);
    }

    if (!discount.percentage) {
      return price;
    }

    return price * (1 - discount.percentage / 100);
  });
}
